import React, { memo } from 'react';
import { Rotate, round, SHAPE_COMPONENT_MAP } from '@wix/seating-common-components';
export const Shapes = memo(({ shapes, onShapeClick, onShapeMouseEnter, onShapeMouseLeave }) => (React.createElement(React.Fragment, null, shapes.map(definition => {
    const ShapeComponent = SHAPE_COMPONENT_MAP[definition.type];
    if (!ShapeComponent) {
        console.error(`Could not render shape of type ${definition.type}.`);
        return null;
    }
    const { width, height, angle } = definition;
    const midX = round(width / 2);
    const midY = round(height / 2);
    return (React.createElement("svg", { key: definition.id, x: definition.x, y: definition.y },
        React.createElement(Rotate, { angle: angle, rotateX: midX, rotateY: midY, gProps: {
                onClick: onShapeClick
                    ? () => {
                        onShapeClick(definition);
                    }
                    : null,
                onMouseEnter: onShapeMouseEnter
                    ? () => {
                        onShapeMouseEnter(definition);
                    }
                    : null,
                onMouseLeave: onShapeMouseLeave
                    ? () => {
                        onShapeMouseLeave(definition);
                    }
                    : null,
            } },
            React.createElement(ShapeComponent, { definition: definition }))));
}))));
//# sourceMappingURL=shapes.js.map